import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.filters = this.element.querySelector('.membership-filters');
    this.filterTemplate = document.getElementById('filter-template');
    this.filtersUpperContainer = this.element.querySelector('.active-filters');
    this.filtersInnerContainer = this.element.querySelector('.the-filters');
    this.dataFilters = this.element.querySelectorAll('[data-item-filter]');
    this.memberships = this.element.querySelectorAll('.membership-card');
    this.filters.addEventListener('input', (event) => this.runFilters(event.target));
  }

  clearFilters() {
    this.dataFilters.forEach((el)=>{
      el.checked = false;
      this.runFilters(el);
    })

  }

  removeFilter(event) {
    const filterElement = this.filters.querySelector('[name="' + event.target.dataset.name + '"]');

    if (filterElement) {
      filterElement.checked = false;
      this.runFilters(filterElement);
    }
  }

  runFilters(target) {
    const currentFilters = [];

    for (const filter of this.filtersInnerContainer.querySelectorAll('.active-filter-item')) {
      filter.remove();
    }

    for (const filter of this.dataFilters) {
      if (filter !== target && filter.name === target.name) {
        filter.checked = false;
      }

      if (filter.checked) {
        currentFilters.push(filter.value);
        const filterNode = this.filterTemplate.cloneNode(true).content;
        filterNode.querySelector('.active-filter-title').innerHTML = filter.dataset.upperTitle + ': ' + filter.dataset.title;
        filterNode.querySelector('.active-filter-close').dataset.name = filter.name;
        this.filtersInnerContainer.appendChild(filterNode);
      }
    }

    if (currentFilters.length) {
      this.filtersUpperContainer.classList.remove('d-none-important')
    } else {
      this.filtersUpperContainer.classList.add('d-none-important')
    }

    for (const card of this.memberships) {
      let active = true;

      for (const filter of currentFilters) {
        if (card.dataset.filterAttributes.indexOf(filter) < 0) {
          active = false;
          break;
        }
      }

      if (active) {
        card.classList.remove('d-none-important');
      } else {
        card.classList.add('d-none-important');
      }
    }
  }
}
